import React from "react";
import styled from "styled-components";

const AboutSection = styled.section`
  padding: 4rem 2rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  max-width: 1200px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const ImageContainer = styled.div`
  flex: 1;
  max-width: 400px;

  img {
    width: 100%;
    height: auto;
    border-radius: 10px;
  }
`;

const TextContainer = styled.div`
  flex: 1;
  max-width: 600px;

  h2 {
    font-size: 2rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1rem;
    color: #000;
    line-height: 1.6;
  }
`;

const SkillsSection = styled.div`
  max-width: 1200px;
  width: 100%;
  text-align: center;

  h3 {
    font-size: 1.8rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 2rem;
  }
`;

const CardGrid = styled.div`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const SkillCard = styled.div`
  background: #f9fafb;
  border-radius: 16px;
  padding: 1.8rem;
  text-align: left;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
  }

  h4 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #222;
    margin-bottom: 0.6rem;
  }

  p {
    font-size: 0.95rem;
    color: #555;
    line-height: 1.5;
  }
`;

function About() {
  return (
    <AboutSection id="about">
      {/* Image + Description */}
      <ContentWrapper>
        <ImageContainer>
          <img src="/assets/comp.jpg" alt="About Me" />
        </ImageContainer>

        <TextContainer>
          <h2>About Me</h2>
          <p>
            I'm a highly skilled and innovative Developer with a passion for
            building scalable, efficient, and user-friendly applications. I
            specialize in React, Next.js, Node.js, TypeScript, Vue.js,
            WordPress, and MongoDB. My focus is on creating clean, maintainable
            code and collaborating with cross-functional teams to deliver
            exceptional digital experiences.
          </p>
        </TextContainer>
      </ContentWrapper>

      {/* Skills Cards */}
      <SkillsSection>
        <h3>What I Can Do</h3>
        <CardGrid>
          <SkillCard>
            <h4>Front-End Development</h4>
            <p>
              Build responsive, accessible interfaces with React and Next.js,
              ensuring smooth performance across all devices.
            </p>
          </SkillCard>
          <SkillCard>
            <h4>Back-End Development</h4>
            <p>
              Design secure, scalable APIs and database architectures using
              Node.js and Express for robust data-driven applications.
            </p>
          </SkillCard>
          <SkillCard>
            <h4>Payment Integration</h4>
            <p>
              Integrate gateways like Stripe, PayPal, or M-Pesa for seamless and
              secure online transactions.
            </p>
          </SkillCard>
          <SkillCard>
            <h4>ERP Solutions</h4>
            <p>
              Develop and customize ERP modules to manage inventory, accounting,
              and other core business operations.
            </p>
          </SkillCard>
          <SkillCard>
            <h4>Deployment & Maintenance</h4>
            <p>
              Deploy apps on Vercel, AWS, or other platforms, with CI/CD,
              monitoring, and ongoing support.
            </p>
          </SkillCard>
          <SkillCard>
            <h4>UI/UX Design</h4>
            <p>
              Create intuitive, visually appealing user interfaces and flows for
              a delightful user experience.
            </p>
          </SkillCard>
        </CardGrid>
      </SkillsSection>
    </AboutSection>
  );
}

export default About;
